import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, reactive, ref } from 'vue';
import TradeListing from 'ah-trades/src/components/lists/TradeListing.vue';
import { Trade, PaginatedResponse } from 'ah-api-gateways';
import { VButton } from 'ah-common-lib/src/common/components';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import TradeDetailsModal from '@/app/components/clientTrades/TradeDetailsModal.vue';
import { TableConfiguration } from 'ah-common-lib/src/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChildTradesRowExpansion',
  props: {
  trade: {
    type: Object as PropType<Trade>,
    required: true,
  },
  listConfig: { type: Object as PropType<TableConfiguration>, required: true },
},
  setup(__props) {



const tradeDetailsModal = ref<InstanceType<typeof TradeDetailsModal> | null>(null);
const listing = ref<InstanceType<typeof TradeListing> | null>(null);

const state = reactive<{
  totalCount: number;
  selectedTrade: Trade | null;
}>({
  totalCount: 0,
  selectedTrade: null,
});

const showingCount = computed(() => {
  return Math.min(state.totalCount, 5);
});

const isChildTradesMoreThanFive = computed(() => {
  return state.totalCount > 5;
});

function onCountsChange(tableData: Partial<PaginatedResponse<Trade>> | null) {
  state.totalCount = tableData?.total ?? 0;
}

function openTradeDetailsModal(item: Trade) {
  state.selectedTrade = item;
  setTimeout(() => {
    tradeDetailsModal.value?.modal?.show();
  });
}

return { __sfc: true,tradeDetailsModal, listing, state, showingCount, isChildTradesMoreThanFive, onCountsChange, openTradeDetailsModal, TradeListing, VButton, MaterialIcon, TradeDetailsModal }
}

})